export default "__VITE_PUBLIC_ASSET__f72e84d9__"